import { SERVICE_TERMS } from "./serviceTerms";

// City landing page content — each city has UNIQUE editorial content
// to avoid Google "doorway pages" duplicate content penalty.

export const CITIES = {
  cannes: {
    slug: "cannes",
    name: "Cannes",
    nameFull: "Cannes",
    path: "/livraison-cannes",
    seoTitle: "NOCTUA RIVIERA — Livraison épicerie de nuit à Cannes 24h/24",
    seoDescription:
      "Épicerie livrée 24h/24 à Cannes : Croisette, Suquet, Palm Beach. Restauration de 11h à 4h. Minimum 30 €, livraison fixe 15 €.",
    heroTagline: "Croisette, Suquet, Californie",
    lede:
      "Cannes ne dort jamais vraiment. Entre les afters du Palm Beach, les fêtes du Festival, les yachts amarrés au Port Canto et les hôtels prestigieux qui accueillent une clientèle internationale exigeante, la ville a besoin d'un service de livraison à la hauteur — 24 heures sur 24, 7 jours sur 7. Noctua Riviera livre pizzas artisanales, plateaux gourmands, champagnes et spiritueux, snacks et tabac dans toute la ville, en 25 minutes en moyenne.",
    neighborhoods: [
      { name: "La Croisette", note: "Front de mer, hôtels emblématiques, terrasses privées." },
      { name: "Le Suquet", note: "Vieille ville, ruelles pavées, appartements en location." },
      { name: "Palm Beach", note: "Casino, clubs et afters — livraisons post-2h fréquentes." },
      { name: "Californie", note: "Résidences privées avec vue mer, villas de standing." },
      { name: "La Bocca", note: "Quartier résidentiel, livraison classique 24/24." },
      { name: "Port Canto & Vieux Port", note: "Livraison à bord des yachts amarrés." },
    ],
    landmarks: [
      "Hôtel Martinez, Carlton, JW Marriott, Barrière Le Majestic — livraison directe conciergerie",
      "Palais des Festivals — durant le Festival de Cannes, livraison prioritaire",
      "Casino Barrière & Palm Beach — champagne et snacks pour tables VIP",
      "Port Canto & Port Pierre Canto — livraison à bord organisée à l'avance",
    ],
    faq: [
      {
        q: "Combien de temps pour une livraison à Cannes ?",
        a: "Environ 20 à 30 minutes dans le centre-ville et sur la Croisette. Comptez 30 à 40 min pour La Bocca ou les résidences en hauteur (Californie, Super-Cannes).",
      },
      {
        q: "Livrez-vous durant le Festival de Cannes ?",
        a: "Oui, avec une priorité renforcée. Nous conseillons de commander 30 min à l'avance pendant la période de fin mai — les rues sont bloquées mais nous avons nos itinéraires alternatifs.",
      },
      {
        q: "Pouvez-vous livrer directement à un hôtel ?",
        a: "Bien sûr, précisez à l'appel le nom de l'hôtel, le numéro de chambre et votre nom. Nous coordonnons avec la conciergerie pour une remise fluide.",
      },
      {
        q: "Livraison à bord d'un yacht au Port Canto ?",
        a: "Oui. Précisez le ponton et le nom du navire lors de la commande. Pour les grosses commandes (planches, magnums), prévenez-nous 45 min à l'avance.",
      },
    ],
    eta: "25 min en moyenne",
    keywords: [
      "livraison Cannes nuit",
      "livraison pizza Cannes nuit",
      "livraison alcool Croisette",
      "épicerie 24/7 Cannes",
      "livraison hôtel Cannes",
      "livraison yacht Cannes",
    ],
  },

  nice: {
    slug: "nice",
    name: "Nice",
    nameFull: "Nice",
    path: "/livraison-nice",
    seoTitle: "NOCTUA RIVIERA — Livraison épicerie de nuit à Nice 24h/24",
    seoDescription:
      "Épicerie livrée 24h/24 à Nice : Vieux-Nice, Promenade, Cimiez. Restauration de 11h à 4h. Minimum 30 €, livraison fixe 15 €.",
    heroTagline: "Vieux-Nice, Promenade, Cimiez",
    lede:
      "Nice est la capitale de la Côte d'Azur, la ville la plus dense et la plus vivante du littoral. De la Promenade des Anglais aux ruelles étroites du Vieux-Nice, des résidences de Cimiez au quartier des Musiciens, Noctua Riviera couvre l'ensemble de la ville. Boissons, snacks et épicerie sont livrés 24h/24 ; les pizzas, pâtes et desserts sont disponibles de 11h à 4h du matin.",
    neighborhoods: [
      { name: "Vieux-Nice", note: "Ruelles pavées, restaurants, bars — livraison à pied fine possible." },
      { name: "Promenade des Anglais", note: "Front de mer, hôtels prestigieux, résidences vue mer." },
      { name: "Cimiez", note: "Quartier résidentiel haut, villas Belle Époque, appartements de standing." },
      { name: "Musiciens & Carré d'Or", note: "Cœur commerçant, immeubles bourgeois." },
      { name: "Port de Nice", note: "Quartier animé, yachts, restaurants ouverts tard." },
      { name: "Libération & Riquier", note: "Quartiers résidentiels vivants, livraison classique." },
      { name: "Fabron & Magnan", note: "Résidences familiales avec vue mer, ouest de la ville." },
    ],
    landmarks: [
      "Hôtel Negresco, Anantara Plaza, Hyatt Regency, Boscolo Exedra — livraison chambres et suites",
      "Aéroport Nice Côte d'Azur — livraison Terminal 1 & 2 (parkings uniquement, pas côté piste)",
      "Rooftops du Méridien, du Beau Rivage, de l'Aston La Scala — livraison après fermeture",
      "Port de Nice — livraison à bord organisée à l'avance",
    ],
    faq: [
      {
        q: "Livrez-vous partout à Nice, même hors centre ?",
        a: "Oui, de l'aéroport à Rimiez, de Magnan à Riquier. Les délais varient : 20-30 min en centre, 30-40 min sur les collines (Cimiez, Fabron).",
      },
      {
        q: "Livraison possible dans le Vieux-Nice ?",
        a: "Oui, le Vieux-Nice est zone piétonne mais nous connaissons parfaitement le quartier. Précisez l'adresse exacte et la ruelle, on trouve toujours.",
      },
      {
        q: "Livraison à l'aéroport de Nice ?",
        a: "Oui, uniquement zone parkings et bornes de dépose-minute. Impossible côté piste ou salle d'embarquement pour des raisons de sécurité.",
      },
      {
        q: "Combien coûte la livraison à Nice ?",
        a: SERVICE_TERMS.minimumAnswer,
      },
    ],
    eta: "25-35 min en moyenne",
    keywords: [
      "livraison Nice nuit",
      "épicerie 24h Nice",
      "livraison pizza Nice",
      "livraison alcool Nice",
      "livraison Promenade des Anglais",
      "livraison Vieux-Nice",
    ],
  },

  monaco: {
    slug: "monaco",
    name: "Monaco",
    nameFull: "Monaco",
    path: "/livraison-monaco",
    seoTitle: "NOCTUA RIVIERA — Livraison épicerie de nuit à Monaco 24h/24",
    seoDescription:
      "Livraison nocturne à Monaco 24h/24 : champagne, spiritueux, plateaux, tabac. Monte-Carlo, La Condamine, Fontvieille, Larvotto. Livraison yacht Port Hercule.",
    heroTagline: "Monte-Carlo, Larvotto, Fontvieille",
    lede:
      "Monaco est un marché à part sur la Côte d'Azur : dense, exigeant, international, et actif 24 heures sur 24. Entre le Casino de Monte-Carlo, les yachts du Port Hercule, la clientèle des palaces (Hôtel de Paris, Métropole, Fairmont) et les résidents du Rocher, Noctua Riviera livre en Principauté avec la même exigence — champagnes prestigieux, spiritueux premium, plateaux charcuterie fine, cigarettes internationales, boissons fraîches. Notre équipe francophone et anglophone est habituée à cette clientèle.",
    neighborhoods: [
      { name: "Monte-Carlo", note: "Casino, palaces, avenues chic. Livraison discrète en chambre." },
      { name: "La Condamine", note: "Autour du Port Hercule, ambiance vivante, résidences." },
      { name: "Fontvieille", note: "Quartier résidentiel calme, héliport, marina." },
      { name: "Larvotto", note: "Plages, résidences de standing, tours One Monte-Carlo." },
      { name: "Le Rocher / Monaco-Ville", note: "Vieille ville, Palais Princier, ruelles étroites." },
      { name: "Jardin Exotique", note: "Hauteurs de Monaco, vues panoramiques, résidences privées." },
      { name: "Port Hercule", note: "Livraison à bord des yachts — service dédié." },
    ],
    landmarks: [
      "Hôtel de Paris, Hermitage, Métropole, Fairmont, Monte-Carlo Bay — livraison discrète en suite",
      "Casino de Monte-Carlo — livraison Cercle Privé et espaces VIP après protocole",
      "Port Hercule — livraison à bord des yachts (jetée nord, jetée principale, digue)",
      "Héliport de Fontvieille — livraison pré/post vol sur demande",
    ],
    faq: [
      {
        q: "Livrez-vous vraiment à Monaco depuis la France ?",
        a: "Oui. Nous traversons la frontière franco-monégasque plusieurs fois par nuit. Aucun surcoût douanier — Monaco fait partie de l'Union douanière européenne via la France.",
      },
      {
        q: "Combien de temps pour une livraison à Monte-Carlo ?",
        a: "En moyenne 35 à 45 minutes depuis notre base, selon le trafic sur la Basse-Corniche. Comptez 30 min pour Fontvieille (accès direct A8).",
      },
      {
        q: "Livraison à bord d'un yacht au Port Hercule ?",
        a: "Absolument. Précisez le nom du navire, le ponton (nord, principale, digue) et prévenez le port à l'avance si accès contrôlé. Pour grosses commandes (magnums, planches complètes), 60 min de préavis idéal.",
      },
      {
        q: "Livrez-vous à l'hôtel Métropole ou l'Hôtel de Paris ?",
        a: "Oui, tous les grands hôtels de Monaco. Nous coordonnons avec la conciergerie pour une remise fluide. Certains palaces exigent un dépôt à la réception — nous vous confirmons le protocole exact à l'appel.",
      },
      {
        q: "Quels moyens de paiement acceptez-vous à Monaco ?",
        a: SERVICE_TERMS.paymentAnswer,
      },
    ],
    eta: "35-45 min en moyenne",
    keywords: [
      "livraison Monaco nuit",
      "livraison Monte-Carlo",
      "champagne livraison Monaco",
      "livraison yacht Port Hercule",
      "livraison hôtel Monaco",
      "épicerie 24h Monaco",
    ],
  },

  antibes: {
    slug: "antibes",
    name: "Antibes",
    nameFull: "Antibes / Juan-les-Pins",
    path: "/livraison-antibes",
    seoTitle: "NOCTUA RIVIERA — Livraison épicerie de nuit à Antibes 24h/24",
    seoDescription:
      "Épicerie livrée 24h/24 à Antibes et Juan-les-Pins, Port Vauban et Cap d'Antibes. Restauration de 11h à 4h. Minimum 30 €, livraison fixe 15 €.",
    heroTagline: "Port Vauban, Vieil Antibes, Cap",
    lede:
      "Antibes-Juan-les-Pins concentre trois univers en un : le Port Vauban et ses yachts géants, le Vieil Antibes historique avec ses remparts et son marché provençal, et Juan-les-Pins avec son casino, ses hôtels de plage et sa vie nocturne intense. Noctua Riviera livre les trois zones toute la nuit, avec un service dédié pour les yachts amarrés au Port Vauban (l'un des plus grands ports de plaisance d'Europe).",
    neighborhoods: [
      { name: "Vieil Antibes", note: "Intra-muros, ruelles piétonnes, hôtels de charme." },
      { name: "Port Vauban", note: "Plus grand port de plaisance de Méditerranée — service yacht dédié." },
      { name: "Juan-les-Pins", note: "Casino, boîtes de nuit, hôtels de plage — livraisons afters." },
      { name: "Cap d'Antibes", note: "Villas privées, Hôtel du Cap-Eden-Roc, résidences prestige." },
      { name: "Salis & Pinède", note: "Quartiers résidentiels tranquilles bord de mer." },
      { name: "La Fontonne", note: "Zone résidentielle nord, familles, livraison classique." },
    ],
    landmarks: [
      "Hôtel du Cap-Eden-Roc, Belles-Rives, Garden Beach — livraison directe suites",
      "Port Vauban — livraison yacht Quai des Milliardaires, Quai Camille Rayon",
      "Casino Eden Beach & Havana Club — livraison afters garantie",
      "Marché Provençal du Cours Masséna — quartier animé la nuit",
    ],
    faq: [
      {
        q: "Livrez-vous au Port Vauban ?",
        a: "Bien sûr, c'est même une de nos zones fortes. Nous connaissons chaque quai — précisez Quai Camille Rayon, Quai des Milliardaires ou pontons visiteurs. Pour les yachts >30m, prévenez la sécurité du port de votre commande.",
      },
      {
        q: "Livraison à Juan-les-Pins après 3h du matin ?",
        a: "Oui, c'est même une de nos périodes de pointe l'été. Les clubs ferment tard, la demande post-club (snacks, boissons, tabac) est forte. Aucun problème.",
      },
      {
        q: "Livrez-vous jusqu'au Cap d'Antibes ?",
        a: "Oui, y compris l'Hôtel du Cap-Eden-Roc et les villas privées. Précisez l'adresse exacte, notre chauffeur vous appellera à l'approche.",
      },
      {
        q: "Délai depuis notre base ?",
        a: "20-30 minutes pour Juan-les-Pins et le centre d'Antibes, 30-40 min pour le Cap et la Fontonne.",
      },
    ],
    eta: "25-35 min en moyenne",
    keywords: [
      "livraison Antibes nuit",
      "livraison Juan-les-Pins",
      "livraison Port Vauban yacht",
      "livraison Cap d'Antibes",
      "épicerie 24h Antibes",
    ],
  },

  villefranche: {
    slug: "villefranche",
    name: "Villefranche",
    nameFull: "Villefranche-sur-Mer",
    path: "/livraison-villefranche",
    seoTitle: "NOCTUA RIVIERA — Livraison épicerie de nuit à Villefranche-sur-Mer 24h/24",
    seoDescription:
      "Épicerie livrée 24h/24 à Villefranche-sur-Mer, Cap-Ferrat et Beaulieu. Restauration de 11h à 4h. Minimum 30 €, livraison fixe 15 €.",
    heroTagline: "Villefranche, Cap-Ferrat, Beaulieu",
    lede:
      "La Rade de Villefranche-sur-Mer est l'un des plus beaux mouillages de la Méditerranée. Yachts, ferries de croisière, résidents des collines et clients des palaces de Cap-Ferrat forment une demande discrète mais exigeante toute la nuit. Noctua Riviera couvre cette zone stratégique — Villefranche, Saint-Jean-Cap-Ferrat, Beaulieu-sur-Mer — avec un service adapté à la clientèle premium locale et internationale.",
    neighborhoods: [
      { name: "Villefranche-sur-Mer centre", note: "Vieille ville, port de la Darse, quais colorés." },
      { name: "Rade de Villefranche", note: "L'un des plus grands mouillages naturels d'Europe — service yacht." },
      { name: "Saint-Jean-Cap-Ferrat", note: "Presqu'île prestigieuse, villas d'exception, Grand-Hôtel." },
      { name: "Beaulieu-sur-Mer", note: "Ville-jardin élégante, Villa Kérylos, résidences Belle Époque." },
      { name: "Cap Ferrat pointe", note: "Villas privées, phare, sentiers du littoral." },
      { name: "Colline de Villefranche", note: "Vues panoramiques, résidences familiales." },
    ],
    landmarks: [
      "Grand-Hôtel du Cap-Ferrat, Royal-Riviera, Métropole Beaulieu — livraison directe",
      "Rade de Villefranche — livraison yacht via tender ou bouée d'accostage",
      "Villa Ephrussi de Rothschild, Villa Kérylos — zone résidentielle prestige",
      "Port de la Darse Villefranche — petits bateaux, résidents plaisanciers",
    ],
    faq: [
      {
        q: "Livraison à un yacht en Rade de Villefranche ?",
        a: "Oui, c'est notre spécialité sur cette zone. Le mouillage étant en pleine mer, la livraison se fait au ponton de Villefranche ou de la Darse — votre tender vient récupérer la commande. Coordonnez-vous avec votre commandant.",
      },
      {
        q: "Livrez-vous jusqu'au bout du Cap-Ferrat ?",
        a: "Oui, y compris les villas isolées, l'Hôtel Grand-Hôtel, et les sentiers piétons du littoral. Précisez bien l'adresse — GPS peut être imprécis sur la presqu'île.",
      },
      {
        q: "Délai depuis notre base ?",
        a: "30-40 minutes pour Villefranche, 35-45 min pour Cap-Ferrat et Beaulieu selon l'accès.",
      },
      {
        q: "Livraison de champagne à un client anglophone ?",
        a: "Yes, our team speaks English. Grocery delivery is available 24/7; pizzas, pasta and desserts are available from 11am to 4am. Minimum order €30, fixed delivery fee €15. Cash, card or secure payment link accepted.",
      },
    ],
    eta: "30-40 min en moyenne",
    keywords: [
      "livraison Villefranche-sur-Mer",
      "livraison Cap-Ferrat",
      "livraison Beaulieu-sur-Mer",
      "livraison yacht Villefranche",
      "épicerie 24h Villefranche",
    ],
  },
};

export const CITY_LIST = Object.values(CITIES);
